/* RESPONSIBLE TEAM: team-actions */
import AppStoreController from './base/appstore';

export default AppStoreController;
